import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { cloneDeep } from 'lodash';
import { validate } from 'validate.js';
import { emailValidator } from '@nile/components/src/Validators/fields';
import { getTranslatedText, InlineMultiTextField } from '@nile/components';
import { reactSelectInlineError } from '@nile/banyan/src/Utils/style';

const ExternalConsultantSection = (props) => {
  const { data, setSharedTech, intl, errors } = props;

  const [validationError, setValidationError] = useState(null);

  const updateChange = (val: any) => {
    setSharedTech({ users: val });
  };
  const itemAddHandler = (val: string) => {
    const data = { email: val };
    const clonedMailList = cloneDeep(data?.users || []);
    clonedMailList.push(data);
    updateChange(clonedMailList);
  };

  const itemRemoveHandler = (val: string) => {
    const filteredMailList = [...(data?.users || [])].filter(
      (mail) => mail.email !== val
    );
    updateChange(filteredMailList);
  };

  const validateEmail = (val: string) => {
    const data = { email: val };
    validate.validators.email.message = getTranslatedText(
      intl,
      'common.validatejs.email.invalid.message'
    );
    const emailError = validate(data, {
      email: emailValidator({
        mandatory: true
      })
    });
    if (emailError) {
      setValidationError(emailError);
      return false;
    }
    setValidationError(null);
    return true;
  };

  return (
    <div className="flex visibilityContainer col">
      <div className={`flex g10 ${data?.users?.length ? 'w70' : 'w350'}`}>
        <div className="mt-5 mr-10">
          <FormattedMessage id="client.details.mail.to" />
        </div>
        <InlineMultiTextField
          showAvatar
          name="item-input"
          label="client.details.mail.to"
          values={data?.users || []}
          placeholder={getTranslatedText(intl, 'common.enter.recipients')}
          onItemAdded={itemAddHandler}
          onItemDeleted={itemRemoveHandler}
          handleValidation={validateEmail}
          charCodes={[188, 13]}
          fontSize="14px"
          itemBackground="#E6E6E6"
          showBorder={props.showBorder}
        />
      </div>
      <div>
        {validationError?.email &&
          reactSelectInlineError(validationError?.email?.[0])}
      </div>
      <div>
        {errors &&
          errors?.[0]?.error?.users?.[0] &&
          reactSelectInlineError(errors?.[0]?.error?.users?.[0])}
      </div>
    </div>
  );
};

export default ExternalConsultantSection;
